//CRUD Controller
export const getAllPath = 'GetAll';
export const getAllByIdsPath = 'GetAllByIds';
export const getAllStubsPath = 'GetAllStubs';
export const getStubsByIdPath = 'GetStubsByIds';
export const getByIdPath = 'GetById';
export const saveAllPath = 'SaveAll';
export const savePath = 'Save';
export const deleteAllPath = 'DeleteAll';
export const deletePath = 'Delete';
export const getCountPath = 'GetCount';
export const getPagePath = 'GetPage';
export const getUserProfilePath = 'GetUserProfile';
//API Key Controller
export const GetAllByUserIDPath = 'GetAllByUserID';
//Auth Controller
export const AuthControllerPath = 'Auth';
export const ResetPasswordPath = 'ResetPassword';
export const ChangePasswordPath = 'ChangePassword';
export const GetUserTenantsPath = 'GetUserTenants';
export const LoginPath = 'Login';
export const LogoutPath = 'Logout';
export const SignUpPath = 'SignUp';
export const UserTenantChangePath = 'UserTenantChange';
export const ChangeConnectionPasswordPath = 'ChangeConnectionPassword';
export const EnableMFAPath = 'EnableMFA';
export const ResetMFAPath = 'ResetMFA';
export const VerifyMFATokenPath = 'VerifyMFAToken';
//Build Info Controller
export const BuildInfoControllerPath = 'BuildInfo';
export const GetBuildInfoPath = 'GetBuildInfo';
//DB Archive Controller
export const archiveExecutionHistoryPath = 'ArchiveExecutionHistory';
export const archiveUniqueItemHistoryPath = 'ArchiveUniqueItemHistory';
//DB Connector Controller
export const testConnectionPath = 'TestConnection';
//Execution History Controller
export const getPageByFlowIDPath = 'GetPageByFlowID';
export const getByExecutionIDPath = 'GetByExecutionID';
export const getLogsForTaskPath = 'GetLogsForTask';
export const getExecutionHistoryPayloadsPath = 'GetExecutionHistoryPayloads';
//Flow Controller
export const getFlowVersionsPath = 'GetFlowVersions';
export const createFlowPath = 'CreateFlow';
export const getAllStubsByReferenceIDsPath = 'GetAllStubsByReferenceIDs';
export const saveBulkPath = 'SaveBulk';
export const getTriggerTaskPagePath = 'GetTriggerTaskPage';
export const promoteIntegrationPath = 'PromoteIntegration';
//TaskExecutorController
export const TaskExecutorControllerPath = 'TaskExecutorController';
export const GetDeployStatePath = 'GetDeployState';
export const StopRunPath = 'StopRun';
//FlowImportExport Controller
export const FlowImportExportControllerPath = 'ImportExportConfig';
export const ExportFlow = 'ExportFlow';
export const ImportFlow = 'ImportFlow';
export const ImportIntegration = 'ImportIntegration';
export const GetFlowParameters = 'GetFlowParameters';
export const UnlinkFile = 'UnlinkFile';
//System Settings Controller
export const getPasswordSettingsPath = 'GetPasswordSettings';
export const savePasswordSettingsPath = 'SavePasswordSettings';
//Expression parser
export const ParseExpression = 'ParseExpression';
export const ExpressionParser = 'ExpressionParser';
//RAG AI
export const RAGControllerPath = 'RagAi';
export const IsEnabledPath = 'IsEnabled';
export const QueryAgentPath = 'QueryAgent';
//Secrets Controller
export const secretsControllerPath = 'SecretConfig';
export const secretsGetScopedSecretsPath = 'GetScopedSecrets';
//Dashboard Controller
export const DashboardControllerPath = 'DashboardConfig';
//Xero Connection Controller
export const xeroConnectionControllerPath = 'XeroConnectionConfig';
export const xeroConnectionGetScopedConnectionsPath = 'GetScopedConnections';
export const xeroOAuthInitiatePath = 'XeroOAuthInitiate';
export const xeroOAuthCallbackPath = 'XeroOAuthCallback';
export const xeroGetTenantsPath = 'XeroGetTenants';
export const xeroDisconnectConnectionPath = 'XeroDisconnectConnection';
//Xero Web App Credentials Controller
export const xeroWebAppCredentialsGetScopedPath = 'GetScopedCredentials';
//HubSpot Connection Controller
export const hubSpotConnectionControllerPath = 'HubSpotConnectionConfig';
export const hubSpotConnectionGetScopedConnectionsPath = 'GetScopedConnections';
export const hubSpotOAuthInitiatePath = 'HubSpotOAuthInitiate';
export const hubSpotOAuthCallbackPath = 'HubSpotOAuthCallback';
export const hubSpotDisconnectConnectionPath = 'HubSpotDisconnectConnection';
export const GetDashboardConfigRequestPath = 'getDashboardConfig';
export const GetDashboardDataRequestPath = 'getDashboardData';
//Xero Controller
export const XeroControllerPath = 'Xero';
export const GetAccountInfoRequestPath = 'GetAccountInfo';
export const GetTaxRatesRequestPath = 'GetTaxRates';
export const GetBrandingThemesRequestPath = 'GetBrandingThemes';
export const GetItemsRequestPath = 'GetItems';
// ScopedPermissionsConfig Controller
export const ScopedPermissionsConfigPath = 'ScopedPermissionsConfig';
